import {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from 'react'
import { DEFAULT_ISA_AVATAR, pickRandomIsaAvatar } from '@/lib/isa-avatars'

interface IsaAvatarContextValue {
  src: string
}

const IsaAvatarContext = createContext<IsaAvatarContextValue | null>(null)

export function IsaAvatarProvider({ children }: { children: ReactNode }) {
  const value = useMemo(
    () => ({ src: pickRandomIsaAvatar() }),
    [],
  )

  return (
    <IsaAvatarContext.Provider value={value}>{children}</IsaAvatarContext.Provider>
  )
}

export function useIsaAvatarSrc(): string {
  const context = useContext(IsaAvatarContext)
  return context?.src ?? DEFAULT_ISA_AVATAR
}
